import {t} from '@lingui/macro'
import * as yup from 'yup'

export const validationSchema = yup.object().shape({
    email: yup
        .string()
        .required(() => t`Email is required`)
        .email(() => t`Invalid email`),
})

export type FormValues = yup.InferType<typeof validationSchema>
